<template>

<div 
    v-on:click="onClick"
    :class="{ 'main' : true, 'main_selected': false, 'main_unread' : true }"
>
    <div class="icon_container">
        <m-avatar
            :avatar="my_avatar"
        />

    </div>
    <div class="summary_container">
        <span class="label_line">Open Contact Requests</span><br/>
        <span class="last_message_line">{{open_count_message}}</span>
    </div>
    <div class="time_container">
    </div>
</div>

</template>

<script>
const Avatar = require('@/js/Avatar.js');
const Labels = require('@/js/Labels.js');

export default {
    props: {
        open_contact_request_info: {
            type: Object,
            default: function() { return {'organization_id' : null, 'employee_id' : null, 'open_contact_requests' : 0}; }
        },
    },

    methods: {
        onClick() {

         this.$router.push({
                'name': 'search-open-contact-requests',
                'params' : {
                    'employee_id' : this.open_contact_request_info.employee_id,
                }
            }).catch(e=>{}); // swallow any exception
        },
    },

    computed: {
        my_avatar() {
            let ret = new Avatar("E164:+11111111111", "E164:+11111111111");

            ret.forceLetter(''+this.open_contact_request_info.open_contact_requests);
            ret.forceColor('#F24653');

            return ret;
        },

        open_count_message() {
            if ( this.open_contact_request_info.open_contact_requests == 1 )
                return 'You have an open contact request';

            return 'You have '+this.open_contact_request_info.open_contact_requests+' open contact requests'
        }
    },
}
</script>

<style lang="scss" scoped>

div.main
{
    width: 100%;
    height: 60px;
   
    display: flex;
    flex-direction: row;

    
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;

    cursor: pointer;
}

div.main:hover,
div.main_selected
{
     background-color: #F1F3F4;
}

div.main_unread
{
    font-weight: 550;
}


div.icon_container
{
    flex-grow: 0;
    
    text-align: center;
}

div.summary_container
{
    flex-grow: 1;
    font-family: Roboto;
   
    padding-left: 16px;
    padding-right: 16px;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 18px;


}

div.time_container
{
    flex-grow: 0;
    font-size: 12px;
    font-family: "Google Sans",Roboto,arial,sans-serif;
}

.label_line
{
    color: #202124;
    font-size: 15px;
}

.last_message_line
{
    color: #202124;
    font-size: 14px;
    max-width: 5em;
}
</style>